var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27505 4.04503C7.03504 2.68168 7.41504 2 7.98315 2C8.55127 2 8.93127 2.68167 9.69126 4.04502L9.88787 4.39774C10.1038 4.78516 10.2118 4.97887 10.3802 5.10668C10.5486 5.2345 10.7582 5.28194 11.1776 5.37683L11.5594 5.46322C13.0352 5.79713 13.7731 5.96409 13.9487 6.52864C14.1243 7.09319 13.6212 7.68144 12.6151 8.85795L12.3548 9.16233C12.0689 9.49666 11.9259 9.66383 11.8616 9.87063C11.7973 10.0774 11.8189 10.3005 11.8622 10.7465L11.9015 11.1526C12.0536 12.7224 12.1297 13.5072 11.6701 13.8561C11.2104 14.205 10.5195 13.8869 9.13775 13.2507L8.78026 13.0861C8.3876 12.9053 8.19127 12.8149 7.98315 12.8149C7.77504 12.8149 7.57871 12.9053 7.18605 13.0861L6.82856 13.2507C5.44676 13.8869 4.75586 14.205 4.29624 13.8561C3.83663 13.5072 3.91268 12.7224 4.06479 11.1526L4.10414 10.7465C4.14737 10.3005 4.16898 10.0774 4.10467 9.87063C4.04036 9.66383 3.89741 9.49666 3.61151 9.16233L3.35121 8.85796C2.3451 7.68144 1.84205 7.09319 2.01761 6.52864C2.19316 5.96409 2.93107 5.79713 4.40688 5.46322L4.78869 5.37683C5.20807 5.28194 5.41775 5.2345 5.58612 5.10668C5.75449 4.97887 5.86247 4.78516 6.07843 4.39774L6.27505 4.04503Z",
    stroke: "currentColor",
    strokeWidth: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.09c978e35d70409563bb89bbe82c4418.svg";
export { ForwardRef as ReactComponent };